import React, { useCallback } from 'react'
import {
  BooleanInput,
  SimpleForm,
  TextInput,
  // PasswordInput,
  email,
  required,
  // minLength,
  useTranslate,
  ReferenceInput,
  AutocompleteInput,
  useCreate,
  useNotify,
  useRedirect,
} from 'react-admin'
// import PersonIcon from '@mui/icons-material/Person'
import { Grid, Box, styled } from '@mui/material'
import { emailPattern } from '../../utils/validators'
import { CreateBase } from '../../components/base'
import { ADMINS_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
// import { AvatarInput } from '../../components/inputs'
import { AccessLevelSelectInput } from '../../components/domains/admins'
import {
  FormBottomToolbarWithPermission,
  // BranchAutocompleteArrayInput,
} from '../../components/form'

const AvatarBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
}))

const AdminCreate: React.FC = () => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const onError = useCallback(
    (error): void => {
      const errorMessage = error.response.data.message
      return notify(errorMessage || 'ra.validation.create_admin_fail', { type: 'error' })
    },
    [notify],
  )
  const onSuccess = useCallback(async (): Promise<void> => {
    notify('ra.notification.create_admin_success', { type: 'success' })
    redirect('/admins')
  }, [notify, redirect])
  const [create] = useCreate(undefined, undefined, { onError, onSuccess })

  const handleSubmit = (data): void => {
    const { access_branches: accessBranches, tel, ...admin } = data
    admin.branch_ids = accessBranches
    admin.tel = tel ? tel : null
    create('admins', {
      data: {
        encType: 'multipart/form-data',
        ...admin,
      },
    })
  }

  return (
    <CreateBase
      title={'resources.admins.create.title'}
      listAction={{
        hasBackButton: true,
      }}
    >
      <SimpleForm onSubmit={handleSubmit} toolbar={<FormBottomToolbarWithPermission />}>
        <Grid container spacing={1} justifyContent='center'>
          <Grid container item spacing={3} xs={12} sm={8} md={7}>
            <Grid item xs={12}>
              <AvatarBox>
                {/* <AvatarInput
                  source='avatar'
                  // label='Avatar'
                  placeholder={<PersonIcon />}
                  accept='image/*'
                /> */}
                {/* <Typography
                  sx={{ color: 'error.main' }}
                  variant='caption'
                  display='block'
                  gutterBottom
                >
                  Allowed *.jpeg, *.jpg, *.png, *.gif
                </Typography> */}
              </AvatarBox>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='firstname_th'
                label={`${ADMINS_FIELDS}.firstname_th`}
                fullWidth
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='lastname_th'
                label={`${ADMINS_FIELDS}.lastname_th`}
                fullWidth
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='firstname_en'
                label={`${ADMINS_FIELDS}.firstname_en`}
                fullWidth
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='lastname_en'
                label={`${ADMINS_FIELDS}.lastname_en`}
                fullWidth
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='user_id'
                label={`${ADMINS_FIELDS}.user_id`}
                fullWidth
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='username'
                label={`${ADMINS_FIELDS}.username`}
                fullWidth
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput
                source='email'
                type='email'
                label={`${ADMINS_FIELDS}.email`}
                fullWidth
                validate={[required(), email('ra.validation.invalid_email'), emailPattern()]}
              />
            </Grid>

            {/* <Grid item xs={12} sm={6}>
              <PasswordInput
                source='password'
                label={`${ADMINS_FIELDS}.password`}
                fullWidth
                validate={[
                  required(),
                  minLength(8, 'ra.validation.password_min_length'),
                  passwordPattern(),
                ]}
                autoComplete='new-password'
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <PasswordInput
                source='confirm_password'
                label={`${ADMINS_FIELDS}.confirm_password`}
                fullWidth
                validate={[
                  required(),
                  minLength(6, 'ra.validation.password_min_length'),
                  isSameData('password', 'ra.validation.password_not_match'),
                ]}
              />
            </Grid>
            <Typography
              sx={{ color: 'common.black', paddingLeft: '24px', paddingTop: '8px', width: '100%' }}
              variant='caption'
              display='block'
              gutterBottom
            >
              {translate(`${ADMINS_FIELDS}.password_conditions`)}
            </Typography>

            <Grid item xs={12} sm={6}>
              <TextInput
                source='tel'
                label={`${ADMINS_FIELDS}.phone`}
                fullWidth
                validate={[isPhoneNumber(true), minLength(9, 'ra.validation.invalid_phone_number')]}
              />
            </Grid> */}

            <Grid item xs={12} sm={6}>
              <ReferenceInput
                key={3}
                filter={{ is_active: true }}
                source='role_id'
                reference='roles'
                label={translate(`${ADMINS_FIELDS}.role`)}
                sort={{
                  field: 'name',
                  order: 'asc',
                }}
              >
                <AutocompleteInput optionText='name' validate={[required()]} size='small' />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12} sm={6}>
              <AccessLevelSelectInput defaultValue='a' disabled/>
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <BranchAutocompleteArrayInput
                source='access_branches'
                depField='access_level'
                expectedValue='s'
                label='Select Branch'
                size='small'
              />
            </Grid> */}
            <Grid item>
              <BooleanInput
                color='primary'
                source='is_active'
                label={`${COMMON_FIELDS}.status.label`}
                defaultValue={true}
              />
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </CreateBase>
  )
}
export default AdminCreate
